import {
	type JSX,
	Suspense,
} from 'react'
import {
	Outlet,
	useLocation,
	useNavigate,
} from 'react-router-dom'

import {
	VStack,
} from '@/shared/components/stack'
import {
	useTelegramBackButton,
} from '@/shared/lib/hooks'
import {
	AppRouterKeys,
} from '@/shared/model/constants'

import {
	BottomNavigationBase,
} from '@/widgets/bottom-navigation'
import {
	NavbarBase,
} from '@/widgets/navbar'
import {
	PageHeaderBase,
	shouldShowPageHeader,
} from '@/widgets/page-header'

export const HomeLayout = (): JSX.Element => {
	const location = useLocation()
	const isHome = location.pathname === AppRouterKeys.HOME
	const showPageHeader = shouldShowPageHeader(location.pathname)
	const navigate = useNavigate()

	useTelegramBackButton(!isHome, () => {
		navigate(-1)
	})

	return (
		<VStack height='100%'>
			<VStack
				flexGrow={1}
				height='100%'
				sx={{
					overflowY: 'auto',
				}}
			>
				{isHome && <NavbarBase />}
				{!isHome && showPageHeader && <PageHeaderBase />}
				<VStack
					sx={{
						flex: '1 1 auto',
					}}
				>
					<Suspense fallback={<div>[HOME_LAYOUT_LOADER]</div>}>
						<Outlet />
					</Suspense>
				</VStack>
			</VStack>
			<BottomNavigationBase />
		</VStack>
	)
}
